module.exports = __webpack_public_path__ + "static/media/logounesul.2f7fabba.png";